import { createFileRoute } from '@tanstack/react-router';
import { AppLayout } from '@/app/shell/app-layout';

/** Organisation-scoped routes: the app shell around every page. */
export const Route = createFileRoute('/_auth/o/$orgId')({
  component: AppLayout,
});
